angular.module('controllers').controller('clientController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$timeout', '$route', '$routeParams', '$location', '$window',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $timeout, $route, $routeParams, $location, $window) {
		$rootScope.path = '/client';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'client';
		$scope.pathTemplate = 'clients/clients';
		$scope.title = 'Clienti';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'client_last_name';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
        $scope.additionals['pathOrder'] = '/order';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'client_last_name':{'label': 'Nume', 'filter': 1, 'filterType': 'input'},
			'client_first_name':{'label': 'Prenume', 'filter': 1, 'filterType': 'input'},
			'client_phone':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
			'client_email':{'label': 'Email', 'filter': 1, 'filterType': 'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};
		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'client_first_name';
        $scope.additionals['columnDisplaySec'] = 'client_last_name';
		$scope.additionals['jsonPath'] = '/json';
		$scope.additionals['address_type'] = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'Casa'},
			{'id':2, 'value' : 'Bloc'},
			{'id':3, 'value' : 'Birou'}
		];

        $scope.additionals['type_orders'] = [
            {'value' : 'order_active', 'name' : 'Comenzi active'},
            {'value' : 'order_cancelled', 'name' : 'Comenzi anulate'}
        ];

        $scope.additionals['discount_types'] = [
            {'id':0, 'value' : 'procent', 'mark' : '%'},
            {'id':1, 'value' : 'suma fixa', 'mark' : ''}
        ];
        $scope.additionals['discount_campaign_value_type'] = {};
        $scope.additionals['discount_campaign_value_type'].options = $scope.additionals['discount_types'];
        $scope.additionals['discount_campaign_types'] = [
            {'id':0, 'value' : 'Reducere one-time'},
            {'id':1, 'value' : 'Reducere multipla'}
        ];
        $scope.additionals['discount_campaign_type'] = {};
        $scope.additionals['discount_campaign_type'].options = $scope.additionals['discount_campaign_types'];

        if (angular.isUndefined($scope.additionals['discount_campaign_times'])) {
            $scope.additionals['discount_campaign_times'] = [];
        }
        $scope.additionals['discount_campaign_times'][0] = {'id':0, 'value' : 'nelimitat'};
        for (var i = 1; i <= 100; i++) {
            $scope.additionals['discount_campaign_times'][i] = {'id':i, 'value' : i};
        }

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0,0,0,0);
        $scope.search.dateFrom = current_init_date;

        $scope.additionals['searchTermSearch'];
        $scope.additionals['clearSearchTermSearch'] = function() {
            $scope.additionals['searchTermSearch'] = '';
        };
        $scope.additionals['onSearchChangeSearch'] = function(ev) {
            ev.stopPropagation();
        };
        $scope.search.county_name = 'Cluj';
        $scope.additionals['getCounties'] = function () {
            Crud.get($scope.additionals['jsonPath'] + '/counties.json')
                .success(function (data) {
                    $scope.additionals['counties'] = data;
                });
        }
        $scope.additionals['getCounties']();

        /* autocomplete */
        function createFilterForLocality(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.locality_name)) {
                    return item.locality_name.indexOf(capitalizeQuery) >= 0;
                } else {return '';}
            };
        }
        function createFilterForSection(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.section_name)) {
                    return item.section_name.indexOf(capitalizeQuery) >= 0;
                } else {
                    return '';
                }
            };
        }
        function createFilterForStreet(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.street_name)) {
                    return item.street_name.indexOf(capitalizeQuery) >= 0;
                } else {
                    return '';
                }
            };
        }
        $scope.additionals['localities'] = [];
        $scope.additionals['getLocalities'] = function(model, indexAddress, index) {
            //model.locality_id = 0;
            Crud.get($scope.path + '/getLocalities?county_name='+model.address[indexAddress].county_name)
                .success(function (dataLoc) {

                    if(dataLoc.localities.length <= 0) {

                        Crud.get($scope.additionals['jsonPath'] + '/localities.json')
                            .success(function (data) {

                                if (angular.isUndefined(model.address[indexAddress].county_name)) {
                                    $scope.additionals['getLocalities']({"county_name": "Cluj"});
                                } else {
                                    if (!angular.isUndefined(index)) {
                                        $scope.additionals['localities' + index] = data[model.address[indexAddress].county_name];
                                    } else {
                                        if (!angular.isUndefined(indexAddress)) {
                                            $scope.additionals['localities'][indexAddress] = data[model.address[indexAddress].county_name];
                                        }
                                    }
                                }
                                /* autocomplete */
                                function querySearch(query, indexAddress) {
                                    if (!angular.isUndefined(index)) {
                                        var results = query ? $scope.additionals['localities'+index].filter(createFilterForLocality(query)) : [];
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['localities'][indexAddress])) {
                                            var results = query ? $scope.additionals['localities'][indexAddress].filter(createFilterForLocality(query)) : [];
                                        } else {
                                            var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                        }
                                    }
                                    return results;
                                }
                                $scope.additionals['searchLocality'] = querySearch;
                                $scope.additionals['errors'] = {};
                                /* end autocomplete */

                            });
                    } else {

                        if (angular.isUndefined(model.address[indexAddress].county_name)) {
                            $scope.additionals['getLocalities']({"county_name": "Cluj"}, indexAddress);
                        } else {
                            if (!angular.isUndefined(index)) {
                                $scope.additionals['localities' + index] = dataLoc['localities'];
                            } else {
                                if (!angular.isUndefined(indexAddress)) {
                                    $scope.additionals['localities'][indexAddress] = dataLoc['localities'];
                                }
                            }
                        }
                        /* autocomplete */
                        function querySearch(query, indexAddress) {
                            if (!angular.isUndefined(index)) {
                                var results = query ? $scope.additionals['localities'+index].filter(createFilterForLocality(query)) : [];
                            } else {
                                if (!angular.isUndefined($scope.additionals['localities'][indexAddress])) {
                                    var results = query ? $scope.additionals['localities'][indexAddress].filter(createFilterForLocality(query)) : [];
                                } else {
                                    var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                }
                            }
                            return results;
                        }
                        $scope.additionals['searchLocality'] = querySearch;
                        $scope.additionals['errors'] = {};
                        /* end autocomplete */
                    }

                });
        }

        $scope.additionals['sections'] = [];
        $scope.additionals['getSections'] = function(model, indexAddress, index) {
            Crud.get($scope.path + '/getSections?county_name='+model.address[indexAddress].county_name+'&locality_name='+model.address[indexAddress].locality_name)
                .success(function (data) {
                    if (!angular.isUndefined(index)) {
                        $scope.additionals['sections' + index] = data['sections'];
                    } else {
                        $scope.additionals['sections'][indexAddress] = data['sections'];
                    }
                    /* autocomplete */
                    function querySearch(query) {
                        if (!angular.isUndefined(index)) {
                            var results = query ? $scope.additionals['sections' + index].filter(createFilterForSection(query)) : [];
                        } else {
                            if (!angular.isUndefined($scope.additionals['sections'][indexAddress])) {
                                var results = query ? $scope.additionals['sections'][indexAddress].filter(createFilterForSection(query)) : [];
                            }
                        }
                        return results;
                    }
                    $scope.additionals['searchSection'] = querySearch;
                    $scope.additionals['errors'] = {};
                    /* end autocomplete */
                });
        }

		$scope.additionals['streets'] = [];
        $scope.additionals['getStreets'] = function(model, indexAddress, index) {
            if (!angular.isUndefined(model.address)) {
                if (model.address[indexAddress].locality_name != '') {
                    if (!angular.isUndefined($scope.additionals['sections'][indexAddress]) && $scope.additionals['sections'][indexAddress].length > 0) {

                        if (model.address[indexAddress].section_name != '') {
                            var pathStreet = $scope.path + '/getStreets?county_name=' + model.address[indexAddress].county_name + '&locality_name=' + model.address[indexAddress].locality_name + '&section_name=' + model.address[indexAddress].section_name;
                        } else {
                            var pathStreet = '';
                            $scope.additionals['streets'][indexAddress] = [];
                            $scope.additionals['searchStreet'] = function querySearch(query) {return '';};
                        }
                    } else {
                        var pathStreet = $scope.path + '/getStreets?county_name=' + model.address[indexAddress].county_name + '&locality_name=' + model.address[indexAddress].locality_name;
                    }

                    if (pathStreet != '') {
                        Crud.get(pathStreet)
                            .success(function (data) {
                                if (!angular.isUndefined(index)) {
                                    $scope.additionals['streets' + index] = data.streets;
                                } else {
                                    $scope.additionals['streets'][indexAddress] = data.streets;
                                }
                                /*autocomplete*/
                                function querySearch(query) {
                                    if (!angular.isUndefined(index)) {
                                        var results = query ? $scope.additionals['streets' + index].filter(createFilterForStreet(query)) : [];
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['streets'][indexAddress])) {
                                            var results = query ? $scope.additionals['streets'][indexAddress].filter(createFilterForStreet(query)) : [];
                                        }
                                    }
                                    return results;
                                }
                                $scope.additionals['searchStreet'] = querySearch;
                                $scope.additionals['errors'] = {};
                                /*end autocomplete*/
                            });
                    }
                }
            }
        }

		$scope.additionals['selectedItemLocality'] = [];
		$scope.additionals['selectedItemStreet'] = [];
        $scope.additionals['selectedItemSection'] = [];

		$scope.additionals['changeSelectAddress']= function(ev, model) {

		}

        $scope.additionals['searchTerm'] = [];
        $scope.additionals['clearSearchTerm'] = function(type, indexAddress) {
            $scope.additionals['searchTerm'][type] = [];
            $scope.additionals['searchTerm'][type][indexAddress] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

		$scope.additionals['function']= function(ev, model) {
			$scope.additionals['address'] = [];
			//$scope.modelData['address'] = [];

            if(model['client_gdpr'] == 0) {
                $scope.modelData.client_gdpr = false;
            }
            if(model['client_gdpr'] == 1) {
                $scope.modelData.client_gdpr = true;
            }

            if(model['client_cutlery'] == 0) {
                $scope.modelData.client_cutlery = false;
            }
            if(model['client_cutlery'] == 1) {
                $scope.modelData.client_cutlery = true;
            }

			if($scope.action == 'update') {
				angular.forEach(model.address, function (item, key) {
					$scope.additionals['getLocalities'](model, key);
					$scope.additionals['getStreets'](model, key);
                    $scope.additionals['getSections'](model, key);
				});
			}
			if ($scope.action != 'updatemultiple') {
				if (angular.isUndefined(model.address) || model.address.length <= 0) {
					model.address = [{}];
					if (angular.isUndefined(model.address[0].county_name)) {
						model.address[0].county_name = 'Cluj';
					}
				}

				var currentModel = {};
				angular.forEach(model, function (item, key) {
					switch (key) {
						case 'address':
							currentModel['address'] = [];
							angular.forEach(item, function (itemAddress, keyAddress) {
								$scope.additionals['selectedItemLocality'][keyAddress] = '';
								$scope.additionals['selectedItemStreet'][keyAddress] = '';

								currentModel['address'][keyAddress] = {};
								angular.forEach(itemAddress, function (itemAddress1, keyAddress1) {
									currentModel['address'][keyAddress][keyAddress1] = itemAddress1;
								});
							});
							break;
						default:
							currentModel[key] = item;
							break;
					}
				});
				$scope.modelData = currentModel;
				if(angular.isUndefined(currentModel.address) || currentModel.address.length == 0) {
					currentModel.address = [{}];
				}
				$scope.additionals['address'] = currentModel.address;

                $scope.additionals['selectedItemStreet'] = '';
                $scope.additionals['selectedItemStreeMultiple'] = '';

                $scope.additionals['selectedItemSection'] = '';
                $scope.additionals['selectedItemSectionMultiple'] = '';
			}
		}

		$scope.additionals['internFunction']= function(ev, model) {
			/*$scope.$watch('modelData', function (item) {
				console.log('here')
				//item.address = $scope.modelData;
				console.log($scope.modelData)

				model = $scope.modelData;
			}, true);*/

			if($scope.action == 'updatemultiple') {

			} else {
				angular.forEach(model.address, function (item, indexAddress) {
                    if (item['locality_name'] != '' && $scope.additionals['localities'][indexAddress]) {
                        if (!angular.isUndefined($scope.additionals['localities'][indexAddress][0]['id'])) {
                            var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities'][indexAddress], 'id', 'locality_name', item['locality_name']);
                            if (checkLocalityId) {
                                item.locality_id = checkLocalityId;
                            } else {
                                item.locality_id = 0;
                            }
                        } else {
                            item.locality_id = 'js';
                        }

                        var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'][indexAddress], 'locality_name', 'locality_name', item['locality_name']);
                        if (checkLocalityName) {
                            item.locality_name = checkLocalityName;
                        } else {
                            if(item.locality_id == 'js') {
                                item.locality_name = '';
                            }
                        }
                    }

                    if (item['section_name'] != '' && $scope.additionals['sections'][indexAddress]) {
                        var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections'][indexAddress], 'id', 'section_name', item['section_name']);
                        if (checkSectionId) {
                            item.section_id = checkSectionId;
                        } else {
                            item.section_id = 0;
                        }
                        var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'][indexAddress], 'section_name', 'section_name', item['section_name']);
                        if (checkSectionName) {
                            item.section_name = checkSectionName;
                        }
                    }

                    if (item['street_name'] != '' && $scope.additionals['streets'][indexAddress]) {
                        var checkStreetId = $scope.additionals['checkField']($scope.additionals['streets'][indexAddress], 'id', 'street_name', item['street_name']);
                        if (checkStreetId) {
                            item.street_id = checkStreetId;
                        } else {
                            item.street_id = 0;
                        }
                        var checkStreetName = $scope.additionals['checkField']($scope.additionals['streets'][indexAddress], 'street_name', 'street_name', item['street_name']);
                        if (checkStreetName) {
                            item.street_name = checkStreetName;
                        }
                    }

				});

			}
		}

		$scope.additionals['functionResult']= function(ev, data) {

			if (!angular.isUndefined($scope.modelData.client_first_name)) {
				$scope.modelData.client_first_name = $scope.additionals['formatTextResult']($scope.modelData.client_first_name);
			}
			if (!angular.isUndefined($scope.modelData.client_last_name)) {
				$scope.modelData.client_last_name = $scope.additionals['formatTextResult']($scope.modelData.client_last_name);
			}
			if (!angular.isUndefined($scope.modelData.street_name)) {
				$scope.modelData.street_name = $scope.additionals['formatTextResult']($scope.modelData.street_name);
			}

			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].client_first_name)) {
						$scope.modelsData[key].client_first_name = $scope.additionals['formatTextResult']($scope.modelsData[key].client_first_name);
						$scope.modelsData[key].client_last_name = $scope.additionals['formatTextResult']($scope.modelsData[key].client_last_name);

					}
				});
			}
		}

		/* add multiple address forms */
		$scope.additionals['address'] = [{}];
		$scope.additionals['cloneItem'] = function (model, modelLength) {
			var itemToClone = {};
			$scope.additionals[model].push(itemToClone);

			angular.forEach($scope.modelData[model], function (item, key) {
				if($scope.action == 'store') {
					$scope.additionals['selectedItemLocality'][$scope.additionals[model].length -1] = '';
					$scope.additionals['selectedItemStreet'][$scope.additionals[model].length -1] = '';

					if (angular.isUndefined(item.county_name)) {
						item.county_name = 'Cluj';
					}
				}
				if($scope.action == 'update') {
					if (angular.isUndefined(item.county_name)) {
						item.county_name = 'Cluj';
					}
				}
			});
		}
		$scope.additionals['removeItem']= function (itemIndex, modelAddress) {

			if(!angular.isUndefined($scope.errors) ) {
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.county_name']) ) {
					delete $scope.errors['address.' + itemIndex + '.county_name'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.locality_name']) ) {
					delete $scope.errors['address.'+itemIndex+'.locality_name'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.section_name']) ) {
					delete $scope.errors['address.'+itemIndex+'.section_name'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_id']) ) {
					delete $scope.errors['address.'+itemIndex+'.street_id'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_no']) ) {
					delete $scope.errors['address.'+itemIndex+'.street_no'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_block']) ) {
					delete $scope.errors['address.'+itemIndex+'.address_block'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_section']) ) {
					delete $scope.errors['address.'+itemIndex+'.address_section'];
				}
                if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_level']) ) {
                    delete $scope.errors['address.'+itemIndex+'.address_level'];
                }
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_flat']) ) {
					delete $scope.errors['address.'+itemIndex+'.address_flat'];
				}
				if(!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_type']) ) {
					delete $scope.errors['address.'+itemIndex+'.address_type'];
				}
			}

			$scope.interm = [];
			angular.forEach($scope.additionals[modelAddress], function (itemy, indexy) {
				$scope.interm[indexy] = {
					'id' : itemy['id'],
					'street_id' : itemy['street_id'],
					'county_name' : itemy['county_name'],
					'locality_name' : itemy['locality_name'],
					'section_name' : itemy['section_name'],
					'street_name' : itemy['street_name'],
					'address_no' : itemy['address_no'],
					'address_block' : itemy['address_block'],
					'address_section' : itemy['address_section'],
                    'address_level' : itemy['address_level'],
					'address_flat' : itemy['address_flat'],
					'address_type' : itemy['address_type']
				};
			});
			$scope.interms = [];
			angular.forEach($scope.interm, function (itemyy, indexyy) {
				$scope.interms.push({
					'id' : itemyy['id'],
					'street_id' : itemyy['street_id'],
					'county_name' : itemyy['county_name'],
					'locality_name' : itemyy['locality_name'],
					'section_name' : itemyy['section_name'],
					'street_name' : itemyy['street_name'],
					'address_no' : itemyy['address_no'],
					'address_block' : itemyy['address_block'],
					'address_section' : itemyy['address_section'],
                    'address_level' : itemyy['address_level'],
					'address_flat' : itemyy['address_flat'],
					'address_type' : itemyy['address_type']
				});
			});

			$scope.interms.splice(itemIndex, 1);
			$scope.additionals[modelAddress] = $scope.interms;

			$timeout(function() {
				/*if(!angular.isUndefined($scope.additionals[model][itemIndex]) ) {
					$scope.modelData.address[itemIndex].county_name = $scope.additionals[model][itemIndex].county_name;
				}*/
				$scope.modelData.address = $scope.additionals[modelAddress];

                $scope.additionals['getLocalities']($scope.modelData, itemIndex);
                $scope.additionals['localities'].splice(itemIndex, 1);

                $scope.additionals['getSections']($scope.modelData, itemIndex);
                $scope.additionals['sections'].splice(itemIndex, 1);

                $scope.additionals['getStreets']($scope.modelData, itemIndex);
                $scope.additionals['streets'].splice(itemIndex, 1);

            }, 100);

		}

        /* close field */
        $scope.additionals['closeField'] = function (paramName, paramId, model, keyAddress, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
                if (!angular.isUndefined(paramId)) {
                    model[key][paramId] = '';
                }
            } else {
                if (!angular.isUndefined(keyAddress)) {
                    model.address[keyAddress][paramName] = '';
                    if (!angular.isUndefined(paramId)) {
                        model.address[keyAddress][paramId] = '';
                    }

                    if(paramName == 'county_name') {
                        $scope.additionals['removeFields']('county', model, keyAddress);
                    }
                    if(paramName == 'locality_name') {
                        $scope.additionals['removeFields']('locality', model, keyAddress);
                    }
                    if(paramName == 'section_name') {
                        $scope.additionals['removeFields']('section', model, keyAddress);
                    }
                    if(paramName == 'street_name') {
                        $scope.additionals['removeFields']('street', model, keyAddress);
                    }

                } else {
                    model[paramName] = '';
                    if (!angular.isUndefined(paramId)) {
                        model[paramId] = '';
                    }
                }
            }
        }

        /* remove fields */
        $scope.additionals['removeFields'] = function (field, modelData, keyAddress) {
            switch (field) {
                case 'county':
                    modelData.address[keyAddress].locality_name='';
                    modelData.address[keyAddress].section_name = '';
                    modelData.address[keyAddress].street_name = '';
                    modelData.address[keyAddress].address_no = '';
                    modelData.address[keyAddress].address_section = '';
                    modelData.address[keyAddress].address_block = '';
                    modelData.address[keyAddress].address_level = '';
                    modelData.address[keyAddress].address_flat = '';
                    modelData.address[keyAddress].address_type = '';
                    break;

                case 'locality':
                    modelData.address[keyAddress].section_name = '';
                    modelData.address[keyAddress].street_name = '';
                    modelData.address[keyAddress].address_no = '';
                    modelData.address[keyAddress].address_section = '';
                    modelData.address[keyAddress].address_block = '';
                    modelData.address[keyAddress].address_level = '';
                    modelData.address[keyAddress].address_flat = '';
                    modelData.address[keyAddress].address_type = '';
                    break;

                case 'section':
                    modelData.address[keyAddress].street_name = '';
                    modelData.address[keyAddress].address_no = '';
                    modelData.address[keyAddress].address_section = '';
                    modelData.address[keyAddress].address_block = '';
                    modelData.address[keyAddress].address_level = '';
                    modelData.address[keyAddress].address_flat = '';
                    modelData.address[keyAddress].address_type = '';
                    break;

                case 'street':
                    modelData.address[keyAddress].address_no = '';
                    modelData.address[keyAddress].address_section = '';
                    modelData.address[keyAddress].address_block = '';
                    modelData.address[keyAddress].address_level = '';
                    modelData.address[keyAddress].address_flat = '';
                    modelData.address[keyAddress].address_type = '';
                    break;
            }
        }

        /* change field */
        $scope.additionals['changeField']= function(model, prop, indexAddress, key) {
            if(prop == 'locality') {
                if (!angular.isUndefined(key)) {
                    model[key].locality_new = false;
                } else {
                    model.address[indexAddress].locality_new = false;
                }
            }
            if(prop == 'section') {
                if (!angular.isUndefined(key)) {
                    model[key].section_new = false;
                } else {
                    model.address[indexAddress].section_new = false;
                }
            }
            if(prop == 'street') {
                if (!angular.isUndefined(key)) {
                    model[key].street_new = false;
                } else {
                    model.address[indexAddress].street_new = false;
                }
            }
        }

        /* detail model */
		$rootScope.detailClient = function () {
			$scope.mode_action = 'dialog';
			Crud.show($routeParams.id, $scope.path)
				.success(function (data) {
					$scope.modelData = data;
				});
		}

        /* reports */
        if($rootScope.settings.enable_packaging == 1) {
            $scope.nonDisplay = 0;
        } else {
            $scope.nonDisplay = 1;
        }
        $scope.printReport = $window;
        $scope.isLoadingPrinter = false;
        $scope.printPreview = function (ev, path, availableColumns, columns) {

            $scope.isLoadingPrinter = true;
            var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
            popup.document.open();

            Crud.search($scope.search, path, 1, 'p')
                .success(function (data) {
                    $scope.isLoadingPagination = false;
                    $scope.isLoadingPrinter = false;

                    $scope.additionals['buttonDisabledPagination'] = false;
                    var printColumns = {};
                    if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                        angular.forEach(columns, function (item, index) {
                            if (availableColumns.indexOf(index) >= 0) {
                                printColumns[index] = item;
                            }
                        });
                    } else {
                        printColumns = columns;
                    }
                    var title = 'Raport ';
                    if($scope.search['reportType'] == 'reportDetail') {
                        title = title + 'detaliat';
                    }
                    if($scope.search['reportType'] == 'reportDaily') {
                        title = title + 'zilnic';
                    }
                    title = title + '  ';
                    if ($scope.search['dateFrom']) {
                        title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeFrom']) {
                        title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                    }
                    if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                        title = title + '   ';
                    }
                    if ($scope.search['dateTo']) {
                        title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeTo']) {
                        title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                    }

                    var html = '<div class="report-print">';
                    var orders = data.data;
                    if (orders.length > 0) {
                        html = html + '<table><tr>';
                        html = html + '<th>Nr.</th>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                html = html + '<th>' + itemColumn['label'] + '</th>';
                            }
                        });
                        html = html + '</tr>';

                        var order_no = 0;
                        var total_amount = 0;
                        var total_shipping = 0;
                        var total_discount = 0;
                        var total_product_discount = 0;
                        var total_client_discount = 0;
                        var total_loyalty_point_discount = 0;
                        var total_packaging = 0;
                        var total = 0;

                        angular.forEach(orders, function (item, key) {
                            html = html + '<tr>';
                            var keys = key + 1;
                            html = html + '<td>' + keys + '</td>';
                            angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                if(!itemColumn['nonDisplay']) {
                                    if (itemColumn['filterType'] == 'select') {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                        } else {
                                            html = html + '<td></td>';
                                        }
                                    } else {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + item[keyColumn] + '</td>';
                                        } else {
                                            html = html + '<td></td>';
                                        }
                                    }
                                }
                            });
                            html = html + '</tr>';

                            order_no = order_no + parseInt(item['order_no']);
                            total_amount = total_amount + parseFloat(item['total_amount']);
                            total_shipping = total_shipping + parseFloat(item['total_shipping']);
                            total_discount = total_discount + parseFloat(item['total_discount']);
                            total_product_discount = total_product_discount + parseFloat(item['total_product_discount']);
                            total_client_discount = total_client_discount + parseFloat(item['total_client_discount']);
                            total_loyalty_point_discount = total_loyalty_point_discount + parseFloat(item['total_loyalty_point_discount']);
                            total_packaging = total_packaging + parseFloat(item['total_packaging']);
                            total = total + parseFloat(item['total']);
                        });

                        html = html + '<tr>';
                        html = html + '<td>Total</td>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                if (keyColumn == 'order_no') {
                                    html = html + '<td class="align-right total">' + order_no + '</td>';
                                } else if (keyColumn == 'total_amount') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_amount) + '</td>';
                                } else if (keyColumn == 'total_product_discount') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_product_discount) + '</td>';
                                } else if (keyColumn == 'total_client_discount') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_client_discount) + '</td>';
                                } else if (keyColumn == 'total_loyalty_point_discount') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_loyalty_point_discount) + '</td>';
                                } else if (keyColumn == 'total_shipping') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_shipping) + '</td>';
                                } else if (keyColumn == 'total_discount') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_discount) + '</td>';
                                } else if (keyColumn == 'total_packaging') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_packaging) + '</td>';
                                } else if (keyColumn == 'total') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total) + '</td>';
                                } else {
                                    html = html + '<td></td>';
                                }
                            }
                        });
                        html = html + '</tr>';

                        html = html + '</table>';
                    }

                    popup.document.write('<!DOCTYPE html><html><head><title>'+ title +'</title>'
                        + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                        + '</head><body onload="window.print(); window.close();">'
                        + html
                        + '</body></html>');
                    //popup.document.close();

                }).error(function (data) {
                $scope.isLoadingPagination = false;
                $scope.errors = data.errors;
            });

        }

        if($location.path() == $scope.path+'/reportDetail') {
            $scope.columns = {
                'client_last_name':{'label': 'Nume', 'filter': 1, 'filterType': 'input'},
                'client_first_name':{'label': 'Prenume', 'filter': 1, 'filterType': 'input'},
                'client_phone':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'client_email':{'label': 'Email', 'filter': 1, 'filterType': 'input'},
                'status':{'label':'Status', 'filter':1, 'filterType':'select'},
                'order_no':{'label':'Nr. comenzi', 'filter':1, 'filterType':'input'},
                'total_amount':{'label':'Total produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_packaging':{'label':'Cost ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
                'total_product_discount':{'label':'Discount produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_client_discount':{'label':'Discount client ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
               // 'total_loyalty_point_discount':{'label':'Discount pct. fidelizare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_shipping':{'label':'Transport ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_discount':{'label':'Discount comanda ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            $scope.columns.status.options = [
                {'id':'', 'value' : ''},
                {'id':1, 'value' : 'true'},
                {'id':0, 'value' : 'false'}
            ];
            $scope.search['reportType'] = 'reportDetail';
            $scope.additionals['reportType'] = 'reportDetail';
            $scope.title = 'Clienti / Raport detaliat';
            $scope.classAction = 'td-small';
        }

        if($location.path() == $scope.path+'/reportGeneral') {
            $scope.columns = {
                'client_name':{'label': 'Nume client', 'filter': 1, 'filterType': 'input'},
                'client_phone':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_no':{'label':'Nr. comenzi', 'filter':1, 'filterType':'input'},
                'total_amount':{'label':'Total produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_packaging':{'label':'Cost ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
                'total_product_discount':{'label':'Discount produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_client_discount':{'label':'Discount client ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                //'total_loyalty_point_discount':{'label':'Discount pct. fidelizare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_shipping':{'label':'Transport ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total_discount':{'label':'Discount comanda ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            $scope.search['reportType'] = 'reportGeneral';
            $scope.additionals['reportType'] = 'reportGeneral';
            $scope.title = 'Clienti / Raport general';
            $scope.classAction = 'td-small';
            $scope.search.order = 'desc';
        }

        /* show model report detail */
        $scope.showModelReportDetail = function (ev, path, modelId) {
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                var typeRequest = 'form-urlencoded';
                var post = $scope.search;
                post['route'] = 'showReportDetail';
                post['id'] = modelId;
                $scope.additionals['buttonDisabled'] = true;
                Crud.post(typeRequest, post, $scope.path + '/showReportDetail')
                    .success(function (data) {
                        $scope.modelData = data;
                        $scope.additionals['buttonDisabled'] = false;
                    });
            }
            if($scope.mode_action == 'dialog') {
                $scope.additionals['buttonDisabled'] = true;
                var typeRequest = 'form-urlencoded';
                var post = $scope.search;
                post['route'] = 'showReportDetail';
                post['id'] = modelId;
                Crud.post(typeRequest, post, $scope.path + '/showReportDetail')
                    .success(function (data) {
                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'showDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                model: data,
                                search: $scope.search,
                                formatText: $scope.formatText,
                                formatDate: $scope.formatDate,
                                columns: $scope.columns,
                                additionals: $scope.additionals
                            },
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.modelData = model;
                            $scope.additionals = additionals;
                            $scope.formatText = formatText;
                            $scope.formatDate = formatDate;
                            $scope.columns = columns;
                            $scope.search = search;

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.additionals['buttonDisabled'] = false;
                        }
                    }).error(function (data) {
                        $scope.errors = data.errors;
                        $scope.additionals['buttonDisabled'] = false;
                    });
            }
        };

        /* show model report general */
        $scope.showModelReportGeneral = function (ev, path, model) {
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.modelData = {};
                $scope.modelData = model;
                if(typeof model.order_nos === 'string') {
                    $scope.modelData.order_nos = model.order_nos.split(', ');
                }
                if(typeof model.order_ids === 'string') {
                    $scope.modelData.order_ids = model.order_ids.split(', ');
                }
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
            }
            if($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportGeneral';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'showDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        search: $scope.search,
                        formatText: $scope.formatText,
                        formatDate: $scope.formatDate,
                        columns: $scope.columns,
                        additionals: $scope.additionals
                    },
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.modelData = model;
                    if(typeof model.order_nos === 'string') {
                        $scope.modelData.order_nos = model.order_nos.split(', ');
                    }
                    if(typeof model.order_ids === 'string') {
                        $scope.modelData.order_ids = model.order_ids.split(', ');
                    }
                    $scope.additionals = additionals;
                    $scope.formatText = formatText;
                    $scope.formatDate = formatDate;
                    $scope.columns = columns;
                    $scope.search = search;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                }
            }
        };

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search = {};

            if($scope.searchControl == true) {
                if(!angular.isUndefined(reportType)) {
                    $scope.search['reportType'] = reportType;
                    $scope.additionals['reportType'] = reportType;
                }
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        /* close date time field */
        $scope.additionals['closeTime'] = function (ev, field, key) {

            if(ev.keyCode == 46) {
                if (angular.isUndefined(key)) {
                    if (field == 'end_time') {
                        $scope.modelDataDiscountCampaign.discount_campaign_end_time = undefined;
                    }
                    if (field == 'start_time') {
                        $scope.modelDataDiscountCampaign.discount_campaign_start_time = undefined;
                    }
                } else {
                    if (field == 'end_time') {
                        $scope.modelsData[key].discount_campaign_end_time = undefined;
                    }
                    if (field == 'start_time') {
                        $scope.modelsData[key].discount_campaign_start_time = undefined;
                    }
                }
            }
        }

        /* add discount campaign */
        $scope.additionals['changeDiscountCampaignType'] = function(modelData) {
            if(modelData.discount_campaign_type == 0) {
                modelData.discount_campaign_times = 1;
            }
        }

        $scope.addDiscountCampaignModel = function (ev, path, modelId) {
            if (angular.isUndefined($scope.modelDataDiscountCampaign)) {
                $scope.modelDataDiscountCampaign = {};
            }
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'adddiscountcampaign';
                $scope.errors = {};
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');
                $scope.additionals['invalid'] = '';
                $scope.cancel = function () {
                    $scope.modelDataDiscountCampaign = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                if (angular.isUndefined($scope.modelDataDiscountCampaign.discount_campaign_start)) {
                    $scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
                }
                $scope.addDiscountCampaign = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    var post = $scope.modelDataDiscountCampaign;
                    post['route'] = 'adddiscountcampaign';
                    post['client_id'] = modelId;
                    Crud.post('form-urlencoded', post, $scope.path + '/addDiscountCampaign')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                            }
                            $scope.modelDataDiscountCampaign = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if(data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                        });
                };
            }

            if($scope.mode_action == 'dialog') {
                if (angular.isUndefined($scope.modelDataDiscountCampaign)) {
                    $scope.modelDataDiscountCampaign = {};
                }
                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'adddiscountcampaign';

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'discountCampaignDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        modelId: modelId,
                        model: $scope.modelDataDiscountCampaign,
                        additionals: $scope.additionals
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'modelId', 'model', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, modelId, model, additionals) {
                    $scope.path = path;
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelDataDiscountCampaign = model;
                    $scope.additionals = additionals;
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                    if (angular.isUndefined($scope.modelDataDiscountCampaign.discount_campaign_start)) {
                        $scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
                    }
                    $scope.addDiscountCampaign = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;
                        var post = $scope.modelDataDiscountCampaign;
                        post['route'] = 'adddiscountcampaign';
                        post['client_id'] = modelId;
                        Crud.post('form-urlencoded', post, $scope.path + '/addDiscountCampaign')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {

                                }
                                $scope.modelDataDiscountCampaign = {};
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if(data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                    };

                }
            }

        };


	}]
);




